(function() {
  const closeableContainer = document.querySelectorAll('.container [data-cmp-closeable]');

  // get all closeable containers
  closeableContainer.forEach(container => {
    let containerId = container.id;
    let cookieName = getCookie(containerId);
    let cookieDomain = window.location.hostname;
    const button = container.querySelectorAll('.button--closeable .cmp-button');

    // check if container has set a cookie.
    // containers are open by default for LCP issues. close only if cookie is found.
    if (cookieName == undefined || cookieName == 'null') {
      openContainer();
    } else {
      closeContainer();
    }
  
    // button actions
    button.forEach(btn => {
      btn.addEventListener('click', function(){
      let parentContainerId = this.closest('[data-cmp-closeable]').id;

      // close its parent container
      this.closest('[data-cmp-closeable]').classList.add('hide');

      // set cookie for its parent 
      setCookie(parentContainerId, 'closed');
      
      });
    });
    
    // Container show-hide
    function closeContainer() {
      container.classList.add('hide');
    }
    
    function openContainer() {
      container.classList.remove('hide');
    }
    
    // Cookies
    function setCookie(containerId, cookieName) {
      document.cookie = containerId + '=' + cookieName + ';domain=' + cookieDomain;
    }

    function getCookie(cookieName) {
      const name = cookieName + '=';
      const cookieDecoded = decodeURIComponent(document.cookie);
      const cookieArr = cookieDecoded .split('; ');
      let results;
      cookieArr.forEach(val => {
          if (val.indexOf(name) === 0) results = val.substring(name.length);
      })
      return results;
  }
  });  
})();